module.exports = __webpack_public_path__ + "static/media/UBCCounsellingServiceBG.310a6303.jpg";